
































































































import { Component, Prop, Vue } from "vue-property-decorator";
import DrawingCanvas from "@/components/drawing-canvas/DrawingCanvas.vue";

@Component({
  components: {
    DrawingCanvas
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PemeriksaanFisik extends Vue {
  @Prop() title = "Pemeriksaan Fisik";

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  canvasWidth = 650;
  canvasHeight = 440;

  fisikImage = null;
  fisikKepala = "";
  fisikLeher = "";
  fisikDada = "";
  fisikParu = "";
  fisikJantung = "";
  fisikPerut = "";
  fisikGenital = "";
  fisikEktrimitaAtas = "";
  fisikEktrimitaBawah = "";
  fisikTubuhBelakang = "";

  updateDrawedImage(image) {
    this.fisikImage = image;
  }

  addDbn(field) {
    if (!this[field]) {
      this[field] = "";
      this[field] = this[field].concat(" Dalam batas normal").trim();
    } else {
      alert(
        "Mohon hapus isian sebelumnya terlebih dahulu untuk menetapkan ini sebagai DBN"
      );
    }
  }

  savePemeriksaanFisik() {
    if (this.readOnly) return;
    //
  }
}
